(function() {
    'use strict';

    console.log('[CompATC] Global delegation script loaded in theme.liquid ✓');

    /* ── money helper ── */
    function formatCartMoney(cents) {
      try {
        var fmt = (window.themeHDN && window.themeHDN.settings && window.themeHDN.settings.moneyFormat)
          ? window.themeHDN.settings.moneyFormat : '${{amount}}';
        return fmt.replace(/\{\{\s*amount[\w]*\s*\}\}/, (cents / 100).toFixed(2));
      } catch(e) { return '$' + (cents / 100).toFixed(2); }
    }

    /* ── badge update ── */
    function updateBadge(n, totalFormatted) {
      console.log('[CompATC] updateBadge → count:', n, 'total:', totalFormatted);
      var hdtCart = document.querySelector('hdt-cart-drawer');
      if (hdtCart) hdtCart.setAttribute('data-count', n);
      document.querySelectorAll('hdt-cart-count').forEach(function(el) {
        el.textContent = n;
        el.style.display = n > 0 ? '' : 'none';
        if (n > 0) el.removeAttribute('hidden');
      });
      if (totalFormatted) {
        document.querySelectorAll('hdt-cart-total').forEach(function(el) { el.textContent = totalFormatted; });
      }
      ['.hdt-mini-cart__count','.hdt-header__cart-count','[data-cart-count]',
       '[data-header-cart-count]','#cart-icon-bubble','.cart-count-bubble span',
       '.t4s-cart-count','.t4s-cart-icon__count'].forEach(function(s) {
        document.querySelectorAll(s).forEach(function(el) {
          el.textContent = n;
          if (n > 0) { el.removeAttribute('hidden'); el.style.display = ''; }
        });
      });
    }

    /* ── cart open ── */
    function openHDTCart() {
      console.log('[CompATC] openHDTCart');
      var hdtCart = document.querySelector('hdt-cart-drawer');
      if (hdtCart && typeof hdtCart.open === 'function') { hdtCart.open(); return; }
      var triggers = ['[aria-controls="CartDrawer"]','[data-cart-drawer-trigger]',
        '.hdt-header__cart','.hdt-header__icon--cart','button[data-cart]',
        'a[href="/cart"].hdt-header__icon','.t4s-site-nav__cart > a',
        '[data-t4s-open-quickcart]','[data-open-quickcart]','.t4s-cart-icon a'];
      for (var i = 0; i < triggers.length; i++) {
        var el = document.querySelector(triggers[i]);
        if (el && !el.closest('#CartDrawer') && !el.closest('hdt-cart-drawer')) { el.click(); return; }
      }
      document.dispatchEvent(new CustomEvent('hdt:cart:open', { bubbles: true }));
    }

    /* ── cart refresh ── */
    function refreshCart() {
      console.log('[CompATC] refreshCart: fetching /cart.js');
      fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          console.log('[CompATC] Cart data:', cart.item_count, 'items');
          updateBadge(cart.item_count, formatCartMoney(cart.total_price));
          var hdtCart = document.querySelector('hdt-cart-drawer');
          if (!hdtCart) { openHDTCart(); return; }
          if (typeof hdtCart.renderContents === 'function') { hdtCart.renderContents(); openHDTCart(); return; }
          if (typeof hdtCart.refresh === 'function') { hdtCart.refresh(); openHDTCart(); return; }
          var sectionId = hdtCart.getAttribute('section-id') || 'cart-drawer';
          fetch('/?sections=' + sectionId, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
            .then(function(r) { return r.json(); })
            .then(function(data) {
              var html = data[sectionId];
              if (html) {
                var doc = new DOMParser().parseFromString(html, 'text/html');
                var fresh = doc.querySelector('cart-items-component');
                var live  = document.querySelector('cart-items-component');
                if (fresh && live) live.replaceWith(fresh);
              }
              openHDTCart();
            }).catch(function() { openHDTCart(); });
        }).catch(function(err) {
          console.error('[CompATC] refreshCart error:', err);
          openHDTCart();
        });
    }

    /* ── ATC fetch ── */
    var _inFlight = {};
    function doATC(variantId, card) {
      if (_inFlight[variantId]) { console.log('[CompATC] Skipping — request already in-flight for', variantId); return; }
      _inFlight[variantId] = true;
      console.log('[CompATC] Adding to cart — variantId:', variantId);

      var btn         = card ? card.querySelector('.hdt-complementary-atc-btn') : null;
      var spinner     = btn  ? btn.querySelector('.hdt-loading__spinner') : null;
      var icon        = btn  ? btn.querySelector('.hdt-complementary-atc-icon') : null;
      var iconSuccess = btn  ? btn.querySelector('.hdt-complementary-atc-icon--success') : null;

      if (btn)     { btn.disabled = true; btn.setAttribute('data-loading', 'true'); }
      if (spinner) spinner.removeAttribute('hidden');
      if (icon)    icon.setAttribute('hidden', '');

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
      .then(function(r) { return r.json().then(function(d) { return { ok: r.ok, data: d }; }); })
      .then(function(result) {
        delete _inFlight[variantId];
        if (spinner) spinner.setAttribute('hidden', '');
        if (result.ok) {
          console.log('[CompATC] Added successfully:', result.data.title);
          if (iconSuccess) iconSuccess.removeAttribute('hidden');
          refreshCart();
          setTimeout(function() {
            var slide = card ? (card.closest('.hdt-slider__slide') || card) : null;
            if (slide) slide.remove();
          }, 800);
        } else {
          console.warn('[CompATC] Add failed:', result.data.description || result.data.message);
          if (btn)         { btn.disabled = false; btn.removeAttribute('data-loading'); }
          if (icon)        icon.removeAttribute('hidden');
          if (iconSuccess) iconSuccess.setAttribute('hidden', '');
        }
      })
      .catch(function(err) {
        delete _inFlight[variantId];
        console.error('[CompATC] Network error:', err);
        if (spinner)     spinner.setAttribute('hidden', '');
        if (btn)         { btn.disabled = false; btn.removeAttribute('data-loading'); }
        if (icon)        icon.removeAttribute('hidden');
        if (iconSuccess) iconSuccess.setAttribute('hidden', '');
      });
    }

   
    document.addEventListener('click', function(e) {
      var el = e.target.closest('[data-complementary-atc]');
      if (!el) return;

      console.log('[CompATC] Click intercepted on:', el.tagName, '| variantId:', el.getAttribute('data-variant-id'));

      e.preventDefault();
      e.stopPropagation();

      var variantId   = el.getAttribute('data-variant-id');
      var isAvailable = el.getAttribute('data-available');

      if (!variantId) { console.warn('[CompATC] No data-variant-id on element'); return; }
      if (isAvailable === 'false') { console.warn('[CompATC] Variant not available'); return; }

      var card = el.closest('.hdt-minicart-recommendations__item');
      if (!card) { console.warn('[CompATC] Could not find parent .hdt-minicart-recommendations__item'); return; }

      var btn = card.querySelector('.hdt-complementary-atc-btn');
      if (btn && btn.getAttribute('data-loading')) { console.log('[CompATC] Button already loading — skipping'); return; }

      doATC(variantId, card);

    }, true /* capture phase */);

    console.log('[CompATC] Capture-phase click listener registered on document ✓');

  })();